import { devtools } from 'zustand/middleware';
import type { StateCreator } from 'zustand';

/**
 * Conditionally applies devtools middleware based on environment
 * In production, this is a no-op to improve performance
 */
export const conditionalDevtools = <T>(
  storeCreator: StateCreator<T, [], [], T>,
  options?: Parameters<typeof devtools>[1]
): StateCreator<T, [], [], T> => {
  // Only apply devtools in development
  if (import.meta.env.DEV) {
    return devtools(storeCreator, options);
  }
  
  // In production, return the store creator as-is
  return storeCreator;
};